<template>
    <div>
        <div class="form-row">
            <div class="col col-12">
                <az-input
                    :placeholder="placeholder ? placeholder : 'Selecione o fornecedor...'"
                    :sizing="sizing ? sizing : 'sm'"
                    :icon="icon ? icon : 'fas fa-plus'"
                    type="autocomplete" 
                    optionsMode="aql"
                    :optionsParm="( parms ? parms : {} )"
                    service="fornecedores.index"
                    v-model="novo_item" 
                    ref="selecao"
                    @selecionado="selecionar_item()">
                    <template v-slot:buttonposb>
                        <slot name="buttonposb"></slot>
                    </template>
                </az-input>
            </div>
        </div>
    </div>
</template>

<script>
//import $ from 'jquery';
//import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            novo_item: null, 
        }
    },

    props: ['sizing',  'placeholder', 'icon', 'parms'],

    components: { 
        AzInput, 
    },

    methods: { 
        filtrar(texto, aspas = false) { 

            if ( aspas ) { 
                texto = '"' + texto + '"';
            }

            this.novo_item = "";

            this.$nextTick(() => { 
                this.$refs.selecao.searchAutoComplete(texto);
            });
        },

        selecionar_item() { 

            this.$nextTick(() => {
                if ( this.novo_item ) { 
                    this.$emit('selecionado', { ...this.novo_item });
                }
                this.novo_item = "";
            });

        },

    }

}
</script>
